module.exports = __webpack_public_path__ + "static/Underdown3-baad06481cac6a108be2865186331b3f.webp";